import React, { forwardRef } from 'react';
import { ChevronDown } from 'lucide-react';
interface FormSelectOption {
  value: string;
  label: string;
}
interface FormSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  helperText?: string;
  options?: FormSelectOption[];
  variant?: 'light' | 'dark';
}
export const FormSelect = forwardRef<HTMLSelectElement, FormSelectProps>(({
  className = '',
  label,
  error,
  helperText,
  options,
  children,
  id,
  variant = 'light',
  ...props
}, ref) => {
  const selectId = id || props.name || Math.random().toString(36).substr(2, 9);
  const lightClasses = `bg-white border-steel-300 text-navy-900`;
  const darkClasses = `bg-navy-900 border-white/10 text-white`;
  const variantClasses = variant === 'dark' ? darkClasses : lightClasses;
  const iconColorClass = variant === 'dark' ? 'text-steel-400' : 'text-steel-500';
  return <div className="w-full" data-id="element-167">
        {label && <label htmlFor={selectId} className={`block text-sm font-bold mb-2 ${variant === 'dark' ? 'text-steel-300' : 'text-navy-900'}`} data-id="element-168">
            {label} {props.required && '*'}
          </label>}

        <div className="relative" data-id="element-169">
          <select id={selectId} ref={ref} className={`
              w-full appearance-none border rounded-sm px-4 py-3 pr-10 
              focus:outline-none focus:ring-1 focus:ring-cg-orange-600 focus:border-cg-orange-600
              disabled:opacity-50 disabled:cursor-not-allowed
              ${variantClasses}
              ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''}
              ${className}
            `} {...props} data-id="element-170">
            {children}
            {options?.map(opt => <option key={opt.value} value={opt.value} data-id="element-171">
                {opt.label}
              </option>)}
          </select>

          <div className={`absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none ${iconColorClass}`} data-id="element-172">
            <ChevronDown className="w-4 h-4" data-id="element-173" />
          </div>
        </div>

        {error && <p className="mt-1 text-xs text-red-600" data-id="element-174">{error}</p>}

        {helperText && !error && <p className="mt-1 text-xs text-steel-500" data-id="element-175">{helperText}</p>}
      </div>;
});
FormSelect.displayName = 'FormSelect';